import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HtmlBase, PropertyData, BObjectModel, QueovalItemModel } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { HttpService, CoreService, FilesManagerService } from '../../../../services';
import { ToastService } from '../../../../toast';


@Component({
  selector: 'q-rum-sepa',
  templateUrl: './rum-sepa.component.html',
  styleUrls: ['./rum-sepa.component.css', '../../dynamictag.component.css']
})
export class RumSepaComponent extends BaseAddOnComponent implements OnInit {
  @Input('model') model: BObjectModel;
  @Input('input') input: PropertyData;
  @Output() inputChange: EventEmitter<PropertyData> = new EventEmitter<PropertyData>(false);
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
  ) { super(); }


  ngOnInit(): void {
  }

  public OnButtonClick(element: HtmlBase): void {
    if (element.TypeModal)
      switch (element.TypeModal.toUpperCase()) {
        case 'RUMSEPA':
          if (this.input.MainElementList[0].Disabled || element.Disabled)
            return;

          this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/RUM_SEPA/${element.OnClick}`).subscribe(
            (result: QueovalItemModel) => {
              this.input.MainElementList[0].Value = result.Ident;
              this.inputChange.emit(this.input);
            });
          break;
        default:
          this.navig.emit(element);
          break;
      }
  }
}
